import Parse from "parse";

export interface OD3_User_SettingAttributes {
  id: string;
  objectId: string;
  createdAt: Date;
  updatedAt: Date;
  preferred_language: string;
}

export class OD3_User_Setting extends Parse.Object<OD3_User_SettingAttributes> {
  static className: string = "OD3_User_Setting";

  constructor(data?: Partial<OD3_User_SettingAttributes>) {
    super("OD3_User_Setting", data as OD3_User_SettingAttributes);
  }

  get preferred_language(): string {
    return super.get("preferred_language");
  }
  set preferred_language(value: string) {
    super.set("preferred_language", value);
  }
}

Parse.Object.registerSubclass("OD3_User_Setting", OD3_User_Setting);
